"use strict";var E=require("../Coerce/enumeration.cjs").enumeration({MESSAGE_TYPE:0,TIMESTAMP:1,PACKAGE_NAMESPACE:2,FEATURE_NUMBER:3,MESSAGE_ID:4,ARGS:5,PIN_LIFETIME:6});exports.MessageIndex=E;
//# sourceMappingURL=MessageIndex.cjs.map
